/**
 * Componente web para pintar un botón de comprar
 */
class MinicarritoHolafly extends HTMLElement{

    /**
     * Contructor
     */
    constructor(){
        super();
        // Click sobre el componente
        this.addEventListener('click', function(e) {
            //console.log("Click en componente"),
            //this.connectedCallback();
        });

        document.getElementById('minicarrito').onclick = function(event) {
            if (event.target.className === 'sumar botones-input') {
                //Do your stuff
                var id_tarjeta = event.target.getAttribute('data-id');
                var cantidad_tarjeta = document.getElementById('producto' + id_tarjeta).value;
                var datos_actualizar = {
                    'id': id_tarjeta,
                    'quantity': parseInt(cantidad_tarjeta) + 1
                }
                var minicarro = new MinicarritoHolafly();
                minicarro.connectedCallback('actualizar', datos_actualizar);
            }

            if (event.target.className === 'restar botones-input') {
                //Do your stuff
                var id_tarjeta = event.target.getAttribute('data-id');
                var cantidad_tarjeta = document.getElementById('producto' + id_tarjeta).value;
                var datos_actualizar = {
                    'id': id_tarjeta,
                    'quantity': parseInt(cantidad_tarjeta) - 1
                }
                var minicarro = new MinicarritoHolafly();
                minicarro.connectedCallback('actualizar', datos_actualizar);
            }


            if (event.target.className === 'eliminar-producto-minicarrito') {
                //Do your stuff
                var id_tarjeta = event.target.getAttribute('data-id');
                var datos_actualizar = {
                    'id': id_tarjeta,
                    'quantity': 0
                }
                var minicarro = new MinicarritoHolafly();
                minicarro.connectedCallback('actualizar', datos_actualizar);
            }

        }

        // Hacer el minicarrito grande
        document.getElementById('agrandar-minicarrito').onclick = function (ev) {
            if (document.getElementById('shopify-section-minicarrito').classList.contains('plegado')) {
                document.getElementById('shopify-section-minicarrito').classList.remove('plegado');
                var body = document.body;
                //body.classList.add("carrito-plegado-abierto");
            }
        }

        // Hacer el minicarrito pequeño
        /*document.getElementById('empequenecer-minicarrito').onclick = function (ev) {
            if (!document.getElementById('shopify-section-minicarrito').classList.contains('plegado')) {
                document.getElementById('shopify-section-minicarrito').classList.add('plegado');
                var body = document.body;
                body.classList.remove("carrito-plegado-abierto");
            }
        }*/

        // Para cerrar el carrito en la cruz del minicarrito
        document.getElementById('cerrar-minicarrito').onclick = function (ev) {
            if (!document.getElementById('shopify-section-minicarrito').classList.contains('oculto')) {
                document.getElementById('shopify-section-minicarrito').classList.add('oculto');
                var body = document.body;
                body.classList.remove("carrito-abierto");
            }
        }

        // Para cerrar el carrito en el boton Seguir comprando
        document.getElementById('seguir-comprando').onclick = function (ev) {
            var ancho = window.matchMedia("(max-width: 900px)");
            if(!ancho.matches){
                // Escritorio
                if (!document.getElementById('shopify-section-minicarrito').classList.contains('oculto')) {
                    document.getElementById('shopify-section-minicarrito').classList.add('oculto');
                    var body = document.body;
                    body.classList.remove("carrito-abierto");
                    //body.classList.remove("carrito-plegado-abierto");
                }
            }else{
                if (!document.getElementById('shopify-section-minicarrito').classList.contains('plegado')) {
                    document.getElementById('shopify-section-minicarrito').classList.add('plegado');
                    var body = document.body;
                    //body.classList.remove("carrito-plegado-abierto");
                }
            }
        }

        // Para abrir el carrito desde el icono de carro del header
        var abrir_carrito = document.getElementsByClassName('abrir-carrito');
        Array.prototype.forEach.call(abrir_carrito, function(el) {
            el.onclick = function (ev) {
                ev.preventDefault();
                if (document.getElementById('shopify-section-minicarrito').classList.contains('oculto')) {
                    document.getElementById('shopify-section-minicarrito').classList.remove('oculto');
                }
                var body = document.body;
                body.classList.add("carrito-abierto");
                document.getElementById('shopify-section-minicarrito').classList.remove('plegado');
                //body.classList.add("carrito-plegado-abierto");
            }
        });

        // Para cerrar el carrito al pinchar fuera de él
        var contenedor_carrito = document.getElementById('shopify-section-minicarrito');
        contenedor_carrito.onclick = function(e){
            if(e.target.id == 'contenedor-minicarrito' || e.target.id == 'contenedor-minicarrito-2'){
                //var ancho = window.matchMedia("(max-width: 900px)");
                //if(!ancho.matches){
                    // Escritorio
                    contenedor_carrito.classList.add('oculto');
                    var body = document.body;
                    body.classList.remove("carrito-abierto");
                //}
            }
        };
    };

    /**
     * Cuando el elemento va a ser insertado en el DOM se dispara este método
     */
    connectedCallback(accion, datos_actualizar){

        var plantilla = '';
        plantilla += '<div id="plantilla-minicarrito"></div>';
        this.innerHTML = plantilla;

        if(accion == 'actualizar'){
            this.llamadaAjax('/cart/change.js', datos_actualizar);
        }else{
            this.llamadaAjax('/cart/update.js');
        }

    };

    llamadaAjax(url, datos_actualizar){

        /*var addData = {
            'line':1,
            'quantity':3
        };*/

        fetch(url, {
            body: JSON.stringify(datos_actualizar),
            credentials: 'same-origin',
            headers: {
                'Content-Type': 'application/json',
                'X-Requested-With':'xmlhttprequest'
            },
            method: 'POST'
        }).then(function(response) {
            return response.json();
        }).then(function(json) {
            // Tenemos JSON
            //console.log(json.items);

            // Carga el minicarrito
            var minicarro = new MinicarritoHolafly();
            // Para cada elemento del carrito
            document.getElementById("plantilla-minicarrito").innerHTML = "";
            json.items.forEach(minicarro.pintarProductos);
            var productos_carrito = json.item_count;
            var precio_carrito = json.total_price / 100;
            var altura = json.items.length * 112;
            /*if(isNaN(altura)){
                altura = json.item_count * 112;
            }*/
            //altura = altura - 280;
            precio_carrito = precio_carrito.toFixed(2);
            document.getElementById('total-minicarrito').innerHTML = "TOTAL: " + precio_carrito + " €";
            document.getElementById('productos-carrito').innerHTML = productos_carrito;
            document.getElementById('plantilla-minicarrito').style.height = altura + "px";
            var burbujas_carrito = document.getElementsByClassName('burbuja-carrito')
            Array.prototype.forEach.call(burbujas_carrito, function(el) {
                // Do stuff here
                el.innerHTML = productos_carrito;
            });
            if(productos_carrito == 0){
                document.getElementById('finalizar-minicarrito').classList.add('btn-desactivado');
            }else{
                document.getElementById('finalizar-minicarrito').classList.remove('btn-desactivado');
            }
        }).catch(function(err) {
            // Error
            console.error(err)
        });
    }

    pintarProductos(elemento){

        // Producto padre
        var producto = document.createElement("div");
        producto.setAttribute("class","produto-minicarrito");

        // Partes del producto padre
        var producto_izquierda = document.createElement("div");
        producto_izquierda.setAttribute("class", 'producto-minicarrito-izquierda');
        var producto_derecha = document.createElement("div");
        producto_derecha.setAttribute("class", 'producto-minicarrito-derecha');

        var cabecera_producto = document.createElement("div");
        cabecera_producto.setAttribute("class", "cabecera-producto-minicarrito");
        var footer_producto = document.createElement("div");
        footer_producto.setAttribute("class", "footer-producto-minicarrito");

        // Imagen del producto
        var imagen = document.createElement("img");
        imagen.setAttribute("src", elemento.image);
        imagen.setAttribute("alt", elemento.product_title);
        imagen.setAttribute("width", '100');
        //producto_izquierda.appendChild(imagen);

        // Título del producto
        var titulo = document.createElement("p");
        titulo.setAttribute("class", "titulo-producto-minicarrito");
        titulo.appendChild(document.createTextNode(elemento.product_title));
        cabecera_producto.appendChild(titulo);

        // Subtítulo del producto
        var subtitulo = document.createElement("p");
        subtitulo.setAttribute("class", "subtitulo-producto-minicarrito");
        if(elemento.variant_title != null){
            subtitulo.appendChild(document.createTextNode(elemento.variant_title));
            cabecera_producto.appendChild(subtitulo);
        }

        /*var mensaje = document.createElement("p");
        mensaje.setAttribute("class", "mensaje-producto-minicarrito solo-escritorio");
        mensaje.innerHTML = "<strong>Envío GRATIS</strong> disponible";
        cabecera_producto.appendChild(mensaje);*/

        var contenedor_input = document.createElement('div');
        contenedor_input.setAttribute("class", "actualizar-producto-minicarrito");
        
        var restar = document.createElement("span");
        restar.setAttribute("id", "restar-" + elemento.id);
        restar.setAttribute("data-id", elemento.id);
        restar.setAttribute("class", "restar botones-input");
        restar.appendChild(document.createTextNode("-"));
        contenedor_input.appendChild(restar);

        var input = document.createElement('input');
        input.setAttribute("type", "number");
        input.setAttribute("class", "input-producto-minicarrito");
        input.setAttribute("id", "producto" + elemento.id);
        input.setAttribute("value", elemento.quantity);
        input.setAttribute("placeholder", elemento.quantity);
        input.appendChild(document.createTextNode(elemento.quantity));
        contenedor_input.appendChild(input);

        var sumar = document.createElement("span");
        sumar.setAttribute("id", "sumar-" + elemento.id);
        sumar.setAttribute("data-id", elemento.id);
        sumar.setAttribute("class", "sumar botones-input");
        sumar.appendChild(document.createTextNode("+"));
        contenedor_input.appendChild(sumar);

        var acciones = document.createElement("div");
        acciones.setAttribute("class", "acciones-producto-minicarrito");
        footer_producto.appendChild(acciones);
        footer_producto.appendChild(contenedor_input);

        var precio = document.createElement('div');
        var precio_total = elemento.price / 100.00;
        precio_total = precio_total.toFixed(0);
        precio.setAttribute("class", "precio-producto-minicarrito");
        precio.appendChild(document.createTextNode(precio_total * elemento.quantity + " €"));
        //acciones.appendChild(precio);

        //var eliminar = document.createElement("span");
        //eliminar.setAttribute("class", "eliminar-producto-minicarrito");
        //eliminar.setAttribute("data-id", elemento.id);
        //eliminar.appendChild(document.createTextNode("eliminar"));
        var eliminar = document.createElement("img");
        eliminar.setAttribute("class", "eliminar-producto-minicarrito");
        eliminar.setAttribute("data-id", elemento.id);
        eliminar.setAttribute('src', '//holafly-b2b.myshopify.com/cdn/shop/t/2/assets/bin-black.svg?v=126113978136880299021728643583');
        acciones.appendChild(eliminar);

        document.getElementById("plantilla-minicarrito").appendChild(producto);
        producto.appendChild(imagen);
        producto.appendChild(producto_izquierda);
        producto.appendChild(producto_derecha);
        producto_izquierda.appendChild(cabecera_producto);
        producto_izquierda.appendChild(precio);
        producto_derecha.appendChild(footer_producto);
    }



}

// Dentro del objeto window, dentro del objeto customElements definimos el Componente que utilizaremos.
window.customElements.define('minicarrito-holafly', MinicarritoHolafly);